import colors from 'globals/colors'
import styled from 'styled-components'
import measures from 'globals/measures'

export const RangeDatePickerWrapper = styled.div`
  position: relative;

  & > button > svg {
    margin-bottom: -1px;
    margin-right: 10px;

    & .color-stroke {
      stroke: white !important;
    }
  }
  
  @media (max-width: ${measures.mobileThreshold}px) {
    & > button > svg {
      margin-right: 0;
    }
    
    & > button > span {
      display: none;
    }
  }
`

interface PickerWrapperProps {
  visible: boolean
}

export const PickerWrapper = styled.div<PickerWrapperProps>`
  background: white;
  border-radius: 4px;
  position: absolute;
  top: 60px;
  left: 0;
  display: none;
  filter: drop-shadow(0px 2px 7px rgba(183, 183, 183, 0.5));
  z-index: 1;
  
  ${(props) => props.visible && `
    display: block;
  `};
  
  & > .rdrDateRangePickerWrapper {
    border-radius: 4px;
    
    @media (max-width: ${measures.mobileThreshold}px) {
      flex-direction: column;
    }
    
    & > .rdrDefinedRangesWrapper {
      border-right: 2px solid ${colors.footerColor};
      border-radius: 4px 0 0 4px;

      @media (max-width: ${measures.mobileThreshold}px) {
        border-right: none;
      }
      
      & > .rdrStaticRanges {
        padding-top: 24px;
        
        & > .rdrStaticRange {
          border: none;
          
          &:hover > span {
            background: ${colors.footerColor};
          }
          
          & > span {
            line-height: 40px;
            font-weight: 600;
            padding: 0 24px;
          }
        }
      }
      
      & > .rdrInputRanges {
        display: none;
      }
    }
    
    & > .rdrCalendarWrapper {
      border-radius: 0 4px 4px 0;
      
      & > .rdrDateDisplayWrapper {
        background: transparent;

        @media (max-width: ${measures.mobileThreshold}px) {
          display: none;
        }
        
        & > .rdrDateDisplay {
          & > .rdrDateDisplayItem {
            background: ${colors.footerColor};
            box-shadow: none;
            border: none;
            
            & > input:placeholder-shown {
              opacity: 0;
            }
          }
        }
      }
      
      & > .rdrMonths {
        @media (max-width: ${measures.mobileThreshold}px) {
          flex-direction: column;
        }
      }
    }
  }
`

export const PickerActions = styled.div`
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
  & > button {
    margin-left: 10px;
  }

  @media (max-width: ${measures.mobileThreshold}px) {
    justify-content: stretch;
    
    & > button {
      flex: 1;
      
      &:first-child {
        margin-left: 0;
      }
    }
  }
`
